const BODY_OPEN_REGEX = /<body[^>]*>/i;
const BODY_CLOSE_REGEX = /<\/body\s*>/i;
const STYLE_TAG_REGEX = /<style[^>]*>([\s\S]*?)<\/style>/gi;

/** Extract all <style>...</style> inner content from a string (e.g. HTML prefix). */
function extractStyleBlocks(html: string): string {
  const blocks: string[] = [];
  let match: RegExpExecArray | null;
  STYLE_TAG_REGEX.lastIndex = 0;
  while ((match = STYLE_TAG_REGEX.exec(html)) !== null) {
    blocks.push(match[1]);
  }
  return blocks.join('\n');
}

/** Parse full HTML into prefix (doctype+head+<body>), headStyles, body inner, and suffix (</body></html>). Returns null if not full document. */
export const parseFullHTML = (
  html: string
): { prefix: string; headStyles: string; bodyInner: string; suffix: string } | null => {
  const lower = html.toLowerCase();
  if (!lower.includes('<html') && !lower.includes('<!doctype')) return null;
  const bodyOpenMatch = html.match(BODY_OPEN_REGEX);
  const bodyCloseMatch = html.match(BODY_CLOSE_REGEX);
  if (!bodyOpenMatch || !bodyCloseMatch) return null;
  const openEnd = bodyOpenMatch.index! + bodyOpenMatch[0].length;
  const closeStart = bodyCloseMatch.index!;
  const prefix = html.slice(0, openEnd);
  return {
    prefix,
    headStyles: extractStyleBlocks(prefix),
    bodyInner: html.slice(openEnd, closeStart),
    suffix: html.slice(closeStart)
  };
};

// Helper function to extract body content from HTML
export const extractBodyContent = (html: string): string => {
  if (!html) return '';

  // Check if content is already just body content (no html/head tags)
  if (!html.includes('<html') && !html.includes('<!doctype')) {
    return html;
  }

  // Extract body tag content
  const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
  if (bodyMatch) {
    return bodyMatch[1];
  }

  // If no body tag, try to extract content between html tags
  const htmlMatch = html.match(/<html[^>]*>([\s\S]*)<\/html>/i);
  if (htmlMatch) {
    // Remove head tag if present
    const withoutHead = htmlMatch[1].replace(/<head[^>]*>[\s\S]*?<\/head>/i, '');
    return withoutHead.trim();
  }

  return html;
};
